import React, { useEffect, useMemo, useState } from "react";
import { Container, UncontrolledTooltip, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody, Table } from "reactstrap";
// import TableContainer from '../../../components/Common/TableContainer';

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TableContainer from "components/Common/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchConfigurationSetup, saveConfigurationSetup } from "store/actions";
import Loader from "common/pageLoader";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const Setup = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [data, setData] = useState([]);
  const {
    setupList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    setupList: state.LoginCreation?.setupList ?? [],

    loading: state.LoginCreation?.loading,
    error: state.LoginCreation?.error,
    success: state.LoginCreation?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchConfigurationSetup(unitId));
  }, [dispatch]);  

  useEffect(() => {
      if(success){
        dispatch(fetchConfigurationSetup(authDetails?.unit_id));
      }
  }, [authDetails,success,dispatch]);

  
  const [editRowId, setEditRowId] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // const columns = [
  //   { Header: "S.No", Cell: ({ row }) => setupList.length - row.index, className: "serial-no", applyHeaderClass: true, },

  //   {
  //     Header: "Description",
  //     accessor: "Descr",
  //   },
  //   {
  //     Header: "Value",
  //     accessor: "Val",
  //     Cell: ({ row }) => {
  //       const isEditing = editRowId === row.original.optn;
  //       const { is_date_value, Val } = row.original;

  //       if (isEditing) {
  //         return is_date_value === 1 ? (
  //           // 🗓️ Date Picker for date values
  //           <DatePicker
  //             format="DD.MM.YYYY"
  //             value={editValue ? dayjs(editValue, "DD.MM.YYYY") : null}
  //             onChange={(date) => {
  //               const formatted = date ? date.format("DD.MM.YYYY") : "";
  //               handleValueChange({ target: { value: formatted } });
  //             }}
  //             onBlur={(e) => e.target.blur()}
  //             allowClear
  //             autoFocus
  //           />
  //         ) : (
  //           // 🔢 Input for numeric values
  //           <Input
  //             type="text"
  //             value={editValue}
  //             onChange={(e) => {
  //               const val = e.target.value;
  //               const regex = /^\d{0,5}(\.\d{0,2})?$/; // up to 5 digits + 2 decimals
  //               if (val === "" || regex.test(val)) {
  //                 handleValueChange(e);
  //               }
  //             }}
  //             onInput={(e) => {
  //               const val = e.target.value;
  //               // auto blur when 1 char entered or cleared
  //               if (val.length === 1 || val.length === 0) e.target.blur();
  //             }}
  //             maxLength={8}
  //             autoFocus
  //           />
  //         );
  //       }

  //       // Non-edit mode: show formatted value
  //       return is_date_value === 1 ? (
  //         <span>{Val ? dayjs(Val, "DD.MM.YYYY").format("DD.MM.YYYY") : "-"}</span>
  //       ) : (
  //         <span>{Val}</span>
  //       );
  //     },
  //   },
  //   {
  //     Header: "Actions",
  //     Cell: ({ row }) => {
  //       const isEditing = editRowId === row.original.optn;
  //       return isEditing ? (
  //         <>

  //           <Button type="button" className="btn button-save btn-sm" onClick={() => handleSaveClick(row.original)}>
  //             <i className="fas fa-save me-1" /> Update
  //           </Button>
  //           {" "}
  //           <Button type="reset" className="btn button-cancel btn-sm" onClick={handleCancelClick}>
  //             <i className="fas fa-sync me-1" /> Cancel
  //           </Button>

  //         </>
  //       ) : (

  //         <Button type="button" className="btn button-print btn-sm" onClick={() => handleEditClick(row.original.optn, row.original.Val)}>
  //           <i className="fas fa-edit me-1" /> Edit
  //         </Button>
  //       );
  //     },
  //   },
  // ];

  const columns = useMemo(() => {
  const baseColumns = [
    {
      Header: "S.No",
      Cell: ({ row }) => setupList.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    {
      Header: "Description",
      accessor: "Descr",
    },
    {
      Header: "Value",
      accessor: "Val",
      Cell: ({ row }) => {
        const isEditing = editRowId === row.original.optn;
        const { is_date_value, Val } = row.original;

        if (isEditing) {
          return is_date_value === 1 ? (
            <DatePicker
              format="DD.MM.YYYY"
              value={editValue ? dayjs(editValue, "DD.MM.YYYY") : null}
              onChange={(date) => {
                const formatted = date ? date.format("DD.MM.YYYY") : "";
                handleValueChange({ target: { value: formatted } });
              }}
              onBlur={(e) => e.target.blur()}
              allowClear
              autoFocus
            />
          ) : (
            <Input
              type="text"
              value={editValue}
              onChange={(e) => {
                const val = e.target.value;
                const regex = /^\d{0,5}(\.\d{0,2})?$/;
                if (val === "" || regex.test(val)) handleValueChange(e);
              }}
              onInput={(e) => {
                const val = e.target.value;
                if (val.length === 1 || val.length === 0) e.target.blur();
              }}
              maxLength={8}
              autoFocus
            />
          );
        }

        return is_date_value === 1 ? (
          <span>{Val ? dayjs(Val, "DD.MM.YYYY").format("DD.MM.YYYY") : "-"}</span>
        ) : (
          <span>{Val}</span>
        );
      },
    },
  ];

  // 👉 Add Actions column only if user has EDIT permission
  if (canEdit) {
    baseColumns.push({
      Header: "Actions",
      Cell: ({ row }) => {
        const isEditing = editRowId === row.original.optn;

        return isEditing ? (
          <>
            <Button
              type="button"
              className="btn button-save btn-sm"
              onClick={() => handleSaveClick(row.original)}
            >
              <i className="fas fa-save me-1" /> Update
            </Button>{" "}
            <Button
              type="reset"
              className="btn button-cancel btn-sm"
              onClick={handleCancelClick}
            >
              <i className="fas fa-sync me-1" /> Cancel
            </Button>
          </>
        ) : (
          <Button
            type="button"
            className="btn button-print btn-sm"
            onClick={() =>
              handleEditClick(row.original.optn, row.original.Val)
            }
          >
            <i className="fas fa-edit me-1" /> Edit
          </Button>
        );
      },
    });
  }

  return baseColumns;
}, [setupList, editRowId, editValue, canEdit]);



  const handleEditClick = (rowId, value) => {
    setEditRowId(rowId);
    setEditValue(value);
  };

  const handleCancelClick = () => {
    setEditRowId(null);
    setEditValue("");
  };

  const handleSaveClick = (row) => {
    let valueToSave = editValue;

    // 🗓️ Convert date value to YYYY-MM-DD if it's a date field
    if (row.is_date_value === 1 && editValue) {
      const parsedDate = dayjs(editValue, ["DD.MM.YYYY", "YYYY-MM-DD"], true);
      if (parsedDate.isValid()) {
        valueToSave = parsedDate.format("YYYY-MM-DD");
      } else {
        console.warn("Invalid date format:", editValue);
        return;
      }
    }

    // 🔢 Build form data
    const formData = new FormData();
    formData.append("unit_id", authDetails.unit_id);
    formData.append("value", valueToSave);
    formData.append("Opt", row.optn);
    formData.append("is_date_value", row.is_date_value);

    // 🚀 Dispatch save action
    dispatch(saveConfigurationSetup(formData));

    // 🧹 Reset editing state
    setEditRowId(null);
    setEditValue("");
  };

  const handleValueChange = (e) => {
    setEditValue(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredData = data.filter((row) =>
    row.Description.toLowerCase().includes(searchQuery)
  );

  const handleSearchCancel = () => {
    setSearchQuery("");
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Configuration" breadcrumbItem="Setup" />

          <Row>
            <Col lg="12">
              {/* <Card>
                <CardBody>
                  <Row className="mb-3">
                    <Col>
                      <div className="d-flex justify-content-between">
                        <Input
                          id="search"
                          type="text"
                          value={searchQuery}
                          onChange={handleSearchChange}
                          placeholder="Search for Configuration Item..."
                          style={{ width: "80%" }}
                        />
                        <Button type="reset" className="btn button-cancel ms-2" size="sm" onClick={handleSearchCancel}>
                          <i className="fas fa-sync me-1" /> Cancel
                        </Button>

                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card> */}
              <Card>
                <CardBody>
                  <TableContainer columns={columns} data={setupList} isGlobalFilter={true} customPageSize={10} className="custom-header-css" />

                  {/* <Table bordered>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Description</th>
                        <th>Value</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((row) => (
                        <tr key={row.optn}>
                          <td>{row.optn}</td>
                          <td>{row.Description}</td>
                          <td>
                            {editRowId === row.optn ? (
                              <Input
                                type="number"
                                value={editValue}
                                onChange={handleValueChange}
                              />
                            ) : (
                              row.Value
                            )}
                          </td>
                          <td>
                            {editRowId === row.optn ? (
                              <>
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() => handleSaveClick(row.optn)}
                                >
                                  Update
                                </Button>{" "}
                                <Button
                                  color="secondary"
                                  size="sm"
                                  onClick={handleCancelClick}
                                >
                                  Cancel
                                </Button>
                              </>
                            ) : (
                              <Button
                                color="primary"
                                size="sm"
                                onClick={() => handleEditClick(row.optn, row.Value)}
                              >
                                Edit
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>


  );
};

export default Setup;
